import wixLocation from 'wix-location';
import wixData from 'wix-data';
import wixWindow from 'wix-window';
import {latestDataUpdate} from 'backend/aModule.jsw'
const viewMode = wixWindow.viewMode;
var wideScreen, showViewAlbumOnLoad
const isMobile = wixWindow.formFactor === "Mobile";
const isTablet = wixWindow.formFactor === "Tablet";

const refreshAlbumData = async () => {
	try {
		await Promise.all([$w("#albumDataset").refresh(), $w("#setsDataset").refresh()])
		const styleParams = JSON.parse($w("#albumDataset").getCurrentItem().gallerySettings)
		$w('#galleryPage1').options = { styleParams: styleParams };
		const logoUrl = $w("#albumDataset").getCurrentItem().logo;
		$w("#htmlLogo").postMessage(logoUrl)
		if (styleParams.allowSocial) {
			if (styleParams.allowDownload) {
				$w('#shareAndDownload').show();
			}
			else {
				$w('#share').show();
			}
		} else {
			if (styleParams.allowDownload) {
				$w('#download').show();
			}
		}
		wixWindow.postMessage({type: 'finishLoadingChanges'})
		return true;
	} catch (e) {
		console.warn('Failed to refresh album data', e);
		return false;
	}
}

const checkForNewDataRecursively = (modifiedTime, maybeAlbumId) => {
	let albumId;
	try {
		albumId = maybeAlbumId || $w("#albumDataset").getCurrentItem().albumId
	} catch (e) {
		setTimeout(() => checkForNewDataRecursively(modifiedTime), 1000);
		return;
	}

	try {
		latestDataUpdate(albumId, modifiedTime).then(async latestUpdate => {
			if(latestUpdate) {
				const refreshedSuccessfully = await refreshAlbumData();
				if(!refreshedSuccessfully) {
					latestUpdate = modifiedTime;
				}
			}
			setTimeout(() => checkForNewDataRecursively((latestUpdate || modifiedTime), albumId), 1000);
		}).catch(e => {
			console.warn('Error in module comunication', JSON.stringify(e))
			setTimeout(() => checkForNewDataRecursively(modifiedTime, albumId), 1000);
		});
	} catch (e) {
		console.warn('Error in module comunication', JSON.stringify(e))
		setTimeout(() => checkForNewDataRecursively(modifiedTime), 1000);
		return;
	}
}

$w.onReady(function () {
	wixWindow.getBoundingRect()
		.then((windowSizeInfo) => {
			let windowHeight = windowSizeInfo.window.height;
			let windowWidth = windowSizeInfo.window.width;
			let scrollY = windowSizeInfo.scroll.y;
			const windowRatio = windowWidth / windowHeight;
			if (windowRatio > 1.5) {
				wideScreen = true;
			}
			if (scrollY < 50 && wideScreen) {
				$w('#box4').show('fade', { duration: 150 })
			}
			if (scrollY < 50) {
				$w('#box1').show('fade', { duration: 100 })
			}
		})

	if (viewMode === "Preview") {
		let filter = wixData.filter();
		filter = filter.eq("status", "draft");
		$w("#albumDataset").setFilter(filter);
		$w("#setsDataset").setFilter(filter);
		$w("#albumDataset").onReady(async () => {
			// await refreshAlbumData();
			checkForNewDataRecursively(0)
		});
	}

	$w("#albumDataset").onReady(() => {
		try {
			$w("#buttonLinkPhotographer").link = $w("#albumDataset").getCurrentItem().motherSitePublicUrl
			$w("#buttonLinkPhotographer").target = '_blank'
			const logoUrl = $w("#albumDataset").getCurrentItem().logo;
			$w("#htmlLogo").postMessage(logoUrl)
			const styleParams = Object.assign(JSON.parse($w("#albumDataset").getCurrentItem().gallerySettings), { alwaysShowHover: false });
			$w('#galleryPage1').options = { styleParams }
			if (styleParams.allowSocial) {
					if (styleParams.allowDownload) {
						$w('#shareAndDownload').show();
					}
					else {
						$w('#share').show();
					}
			} else {
				if (styleParams.allowDownload) {
					$w('#download').show();
				}
			}
			$w('#setsDataset').onReady(() => {
			$w('#downloadButton').link = $w("#setsDataset").getCurrentItem().zipUrl;
			$w('#downloadButton2').link = $w("#setsDataset").getCurrentItem().zipUrl;
			$w('#downloadIconMobile').link = $w("#setsDataset").getCurrentItem().zipUrl;
			$w('#downloadIconMobile2').link = $w("#setsDataset").getCurrentItem().zipUrl;
		})
		} catch (e) {

		}
	})
});

$w.onReady(function () {
	
	$w('#facebook').link = `https://www.facebook.com/sharer/sharer.php?u=${wixLocation.url}`;
	$w('#facebook').target = "_blank"
	$w('#facebook2').link = `https://www.facebook.com/sharer/sharer.php?u=${wixLocation.url}`;
	$w('#facebook2').target = "_blank"

	$w('#twitter').link = `http://twitter.com/share?url=${wixLocation.url}`;
	$w('#twitter').target = "_blank";
	$w('#twitter2').link = `http://twitter.com/share?url=${wixLocation.url}`;
	$w('#twitter2').target = "_blank";

	$w('#pinterest').link = `http://pinterest.com/pin/create/button/?url=${wixLocation.url}`;
	$w('#pinterest').target = "_blank";
	$w('#pinterest2').link = `http://pinterest.com/pin/create/button/?url=${wixLocation.url}`;
	$w('#pinterest2').target = "_blank";

	$w('#tumblr').link = `http://tumblr.com/share/link?url=${wixLocation.url}`;
	$w('#tumblr').target = "_blank";
	$w('#tumblr2').link = `http://tumblr.com/share/link?url=${wixLocation.url}`;
	$w('#tumblr2').target = "_blank";

	$w('#email').link = `mailto:?body=Check out this site%0D%0A${wixLocation.url}.&subject=I wanted you to see this site`;
	$w('#email').target = "_blank";
	$w('#email2').link = `mailto:?body=Check out this site%0D%0A${wixLocation.url}.&subject=I wanted you to see this site`;
	$w('#email2').target = "_blank";

});



export function columnStrip3_viewportEnter(event) {
	$w('#box1').show('fade', { duration: 100 });

}

export function columnStrip3_viewportLeave(event) {
	$w('#box1').hide('fade', { duration: 100 });
}

export function columnStrip5_viewportEnter(event) {
	$w('#box4').hide('fade', { duration: 50 });
}

export function columnStripShowMobileMenu2_viewportLeave(event) {
	$w('#vectorPage1MenuIcon2').show()

}

export function columnStripShowMobileMenu2_viewportEnter(event) {
	$w('#vectorPage1MenuIcon2').hide()
}

export function vectorPage1MenuIcon_viewportLeave(event) {
	$w('#vectorPage1MenuIcon2').hide()
}

export function columnStrip11_viewportLeave(event) {
	$w('#box4').show('fade', { duration: 50 })
}

// export function stripShowShare_viewportEnter(event) {
// 	$w('#shareContainer').show('fade', { duration: 50 }) 
// }



// export function stripHideShare_viewportEnter(event) {
// 	$w('#shareContainer').hide('fade', { duration: 50 })
// }